'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getFullItemDetails = _ref => {
  var _claimEligibilityInfo;
  let {
    claimEligibilityInfo,
    itemUid,
    packageId
  } = _ref;
  const shipmentItem = claimEligibilityInfo === null || claimEligibilityInfo === void 0 ? void 0 : (_claimEligibilityInfo = claimEligibilityInfo.shipments.find(shipment => shipment.id === packageId)) === null || _claimEligibilityInfo === void 0 ? void 0 : _claimEligibilityInfo.items.find(item => item.itemRefId === itemUid);
  const orderItem = claimEligibilityInfo === null || claimEligibilityInfo === void 0 ? void 0 : claimEligibilityInfo.items[itemUid];
  if (!orderItem || !shipmentItem) return null;
  return {
    uid: itemUid,
    currency: orderItem.currency,
    name: orderItem.name,
    color: orderItem.color,
    size: orderItem.size,
    thumbnailUrl: orderItem.thumbnailUrl,
    unitPrice: orderItem.unitPrice,
    unitTax: orderItem.unitTax,
    eligibility: shipmentItem.eligibility,
    remainingEligibleQuantity: orderItem.remainingEligibleQuantity,
    quantity: shipmentItem.quantity,
    itemId: shipmentItem.itemId,
    sku: shipmentItem.sku,
    evaluatedEligibility: shipmentItem.evaluatedEligibility
  };
};

exports["default"] = getFullItemDetails;
